import { useGraphqlQuery } from "@bsm/component"
import { TTimeOff } from "@bsm/graphql"
import { TimeOffQuery } from "queries/TimeOffQuery"

export const useTimeOffQuery = (id?:number,suspense?:boolean, enabled?: boolean)=>{
    return useGraphqlQuery<TimeOffQuery,TTimeOff>(new TimeOffQuery({ id }), { enabled: enabled !== false && id !== undefined, suspense })
}